import React, { useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { ReelControls } from './components/reel/ReelControls';
import { ReelStage } from './components/reel/ReelStage';
import { REEL_DURATION } from './data/reel';
import { useDubTechno } from './hooks/useDubTechno';
import { useReelClock } from './hooks/useReelClock';
interface AppProps {
  /** "hero" embeds the reel in a rounded frame; "fullbleed" fills the viewport for screen recording. */
  frame?: 'hero' | 'fullbleed';
}
export function App({
  frame = 'hero'
}: AppProps) {
  const reduceMotion = useReducedMotion();
  const {
    time,
    timeRef,
    playing,
    toggle
  } = useReelClock(REEL_DURATION, !reduceMotion);
  const [soundOn, setSoundOn] = useState(true);
  useDubTechno(timeRef, playing, soundOn);
  const controls = <ReelControls playing={playing} soundOn={soundOn} onToggle={toggle} onToggleSound={() => setSoundOn(s => !s)} data-id="element-0" data-mp="28tw4ipctkg2e" />;
  if (frame === 'fullbleed') {
    return <main className="flex h-screen w-full items-center justify-center bg-cream" data-id="element-1" data-mp="23ti6m04xmmi3">
        <div className="relative" style={{
        width: 'min(100vw, calc(100vh * 16 / 9))'
      }} data-id="element-2" data-mp="3ihv22ef0kliv">
          <ReelStage time={time} data-id="element-3" data-mp="3mjq27fl7ksv2" />
          {controls}
        </div>
      </main>;
  }
  return <main className="min-h-screen w-full bg-cream px-5 py-8 font-sans text-ink md:px-12 md:py-14" data-id="element-4" data-mp="3rd19fhtxnbni">
      <div className="mx-auto max-w-[1440px]" data-id="element-5" data-mp="56l3b4umzkw">
        <section aria-label="David D. Vallejo — portfolio reel" className="relative overflow-hidden rounded-[24px] md:rounded-[44px]" data-id="element-6" data-mp="2zllduyaeeel5">
          <ReelStage time={time} data-id="element-7" data-mp="33n6yx6x35z6f" />
          {controls}
        </section>
      </div>
    </main>;
}